export default __webpack_public_path__ + "static/media/19-min.8fff6c25.jpg";